import { useQuery } from '@tanstack/react-query';

// common
import { handleException } from 'modules/account/detail/helpers/utils';
import useService from 'common/hook/useService';

export interface DepartmentDetailInfo {
  orgType: string;
  operationCode: string;
  name: string;
  city: string;
  district: string;
  status: boolean;
  description: string;
}

interface Props {
  id: string;
  orgType: string; //   'HVS' | 'KHDN' | 'CQQL'
}

/**
 * Dữ liệu chi tiết của 1 đơn vị phòng ban
 */
const useGetDepartmentDetail = ({ id, orgType }: Props) => {
  const service = useService();

  return useQuery({
    queryKey: [id, orgType],
    queryFn: async () => {
      try {
        if (!service) return null;

        const result =
          orgType === 'HVS'
            ? await service.KiosController_getHvsInfo()
            : orgType === 'KHDN'
              ? await service.KiosController_getClientDetails({ params: { code: id } })
              : await service.KiosController_getGovAgencyDetails({ params: { code: id } });

        const r = result as {
          operationCode?: string;
          name?: string;
          cityName?: string;
          districtName?: string;
          city?: string;
          district?: string;
          description?: string;
        };
        const details: DepartmentDetailInfo = {
          orgType,
          operationCode: r.operationCode ?? '',
          name: r.name ?? '',
          status: true,
          city: `${orgType === 'HVS' ? (r.cityName ?? '') : (r.city ?? '')}`,
          district: `${orgType === 'HVS' ? (r.districtName ?? '') : (r.district ?? '')}`,
          description: r.description ?? '',
        };
        return details;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useGetDepartmentDetail;
